import prettylink from 'prettylink';

const bitly = new prettylink.Bitly('5a07155412bfe07d9847179ad120d1679749d1ed');

export default bitly;